import URI from 'jsuri';
import Q from 'q';

import API from 'js/lib/api';

import type { PartnerTypeValuesType } from '../constants/PartnerType';

// @ts-expect-error ts-migrate(2345) FIXME: Argument of type '{ ype: string; }' is not assigna... Remove this comment to see the full error message
const authoringPartnerAPI = API('/api/authoringPartners.v1/', { ype: 'rest' });

const AuthoringPartnerAPIUtils = {
  getPartnerForAuthoring(partnerId: $TSFixMe) {
    const uri = new URI(partnerId).addQueryParam(
      'fields',
      `name, shortName, description, abbrName, homeLink, primaryColor, secondaryColor, accentColor, links,
        landingPageBanner, logo, display, classLogo, squareLogo, rectangularLogo, productBrandingLogo, location, partnerType`
    );

    return Q(authoringPartnerAPI.get(uri.toString()));
  },

  getAuthoringPartnerByShortName(shortName: $TSFixMe) {
    const uri = new URI().addQueryParam('q', 'byShortName').addQueryParam('shortName', shortName);

    return Q(authoringPartnerAPI.get(uri.toString()));
  },

  createNewPartner(name: string, shortName: string, abbrName: string, partnerType: PartnerTypeValuesType) {
    const data = JSON.stringify({
      name,
      shortName,
      abbrName,
      partnerType,
      display: false,
    });

    const uri = new URI();
    return Q(authoringPartnerAPI.post(uri.toString(), { data }));
  },

  updatePartner(partner: $TSFixMe) {
    const data = JSON.stringify(partner);

    const uri = new URI(partner.id);
    return Q(authoringPartnerAPI.put(uri.toString(), { data }));
  },
};

export default AuthoringPartnerAPIUtils;

export const { getPartnerForAuthoring, getAuthoringPartnerByShortName, createNewPartner, updatePartner } =
  AuthoringPartnerAPIUtils;
